import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export function ThemeToggle() {
  const [dark, setDark] = useState(() => localStorage.getItem("arrow_theme") !== "light");

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("arrow_theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <button
      data-testid="theme-toggle"
      onClick={() => setDark((d) => !d)}
      className="h-9 w-9 grid place-items-center border border-border bg-card hover:bg-primary hover:text-primary-foreground transition-colors"
      aria-label="Toggle theme"
    >
      {dark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
